export default (function (_ref) {
  var request = _ref.request;
  return {
    areaWarnAdd: function areaWarnAdd(data) {
      return request({
        url: '/disease/areaWarn/add',
        method: 'post',
        data: data
      });
    },
    areaWarnModify: function areaWarnModify(data) {
      return request({
        url: "/disease/areaWarn/".concat(data.id, "/modify"),
        method: 'put',
        data: data
      });
    },
    areaWarnDel: function areaWarnDel(id) {
      return request({
        url: "/disease/areaWarn/".concat(id, "/del"),
        method: 'delete'
      });
    },
    areaWarnQuery: function areaWarnQuery(data) {
      return request({
        url: '/disease/areaWarn/query',
        method: 'get',
        params: data
      });
    },
    areaWarnDetail: function areaWarnDetail(id) {
      return request({
        url: "/disease/areaWarn/".concat(id, "/detail"),
        method: 'get'
      });
    },
    areaWarnReportDiseasesType: function areaWarnReportDiseasesType() {
      return request({
        url: "/disease/areaWarn/report/diseasesType",
        method: 'get'
      });
    },
    areaWarnReportDiseasesName: function areaWarnReportDiseasesName() {
      return request({
        url: "/disease/areaWarn/report/diseasesName",
        method: 'get'
      });
    }
  };
});